import React, { useEffect } from "react";
import { useNewsletterModal } from "@/lib/modal";
import NewsletterForm from "@/components/NewsletterForm";
import { X } from "lucide-react";

export default function NewsletterModal() {
    const { isNewsletterOpen, closeNewsletter } = useNewsletterModal();

    useEffect(() => {
        if (isNewsletterOpen) document.body.style.overflow = "hidden";
        else document.body.style.overflow = "";
        return () => {
            document.body.style.overflow = "";
        };
    }, [isNewsletterOpen]);

    useEffect(() => {
        if (!isNewsletterOpen) return;
        const onKey = (e) => {
            if (e.key === "Escape") closeNewsletter();
        };
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [isNewsletterOpen, closeNewsletter]);

    if (!isNewsletterOpen) return null;

    return (
        <div
            className="fixed inset-0 z-[100] flex items-center justify-center p-4 fade-up"
            style={{
                background: "rgba(10,13,18,0.55)",
                backdropFilter: "blur(8px)",
                animationDuration: "0.2s",
            }}
            onClick={closeNewsletter}
            data-testid="newsletter-modal"
        >
            <div
                className="w-full max-w-[520px] p-8 md:p-10 relative"
                style={{
                    background: "white",
                    border: "1px solid var(--rule)",
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <button
                    type="button"
                    onClick={closeNewsletter}
                    className="absolute top-4 right-4 p-1.5 hover:opacity-70 transition-opacity"
                    style={{ color: "var(--ink-2)" }}
                    aria-label="Close"
                    data-testid="newsletter-modal-close"
                >
                    <X size={18} />
                </button>
                <NewsletterForm onClose={closeNewsletter} autoFocus bg="steel" />
            </div>
        </div>
    );
}
